var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Stack, Button, Text, Alert, } from '@noom/wax-component-library';
import InfiniteScroll from 'react-infinite-scroller';
import { NotificationRecordItem, NotificationRecordSkeleton } from './NotificationRecordItem';
const Wrap = forwardRef((_a, ref) => {
    var { children } = _a, style = __rest(_a, ["children"]);
    return (React.createElement(Box, Object.assign({ display: "flex", flexDir: "column", overflow: "auto", ref: ref }, style), children));
});
export function Skeleton(_a) {
    var { numOfRows = 3 } = _a, style = __rest(_a, ["numOfRows"]);
    return (React.createElement(Stack, Object.assign({ spacing: "-1px", mb: "-1px", w: "100%" }, style), [...Array(numOfRows).keys()].map((i) => (React.createElement(NotificationRecordSkeleton, { key: i })))));
}
function MarkAllButton(props) {
    return (React.createElement(Button, Object.assign({ variant: "link", w: "100%", size: "sm", colorScheme: "primary", fontWeight: "normal" }, props),
        React.createElement(FormattedMessage, { id: "notificationTray.markAllRead" })));
}
export function NotificationRecordListHeader(_a) {
    var { isDisabled, titleProps, onMarkAllClick, showMarkAll } = _a, style = __rest(_a, ["isDisabled", "titleProps", "onMarkAllClick", "showMarkAll"]);
    return (React.createElement(Box, Object.assign({ display: "flex", justifyContent: "space-between" }, style),
        React.createElement(Text, Object.assign({ fontWeight: "500", fontSize: "md" }, titleProps),
            React.createElement(FormattedMessage, { id: "notificationTray.title" })),
        showMarkAll && (React.createElement(MarkAllButton, { isDisabled: isDisabled, onClick: onMarkAllClick, display: "inline-flex", w: "auto" }))));
}
export function NotificationRecordList(_a) {
    var { error, height, isLoading, numOfSkeletonRows, notificationRecords, hasMore = false, loadMore = () => { }, onClick, onBadgeClick } = _a, style = __rest(_a, ["error", "height", "isLoading", "numOfSkeletonRows", "notificationRecords", "hasMore", "loadMore", "onClick", "onBadgeClick"]);
    const wrapRef = useRef(null);
    if (isLoading) {
        return (React.createElement(Wrap, Object.assign({}, style, { ref: wrapRef }),
            React.createElement(Skeleton, { numOfRows: numOfSkeletonRows })));
    }
    if (error) {
        return (React.createElement(Wrap, Object.assign({}, style, { ref: wrapRef }),
            React.createElement(Alert, { status: "error", w: "100%" }, error)));
    }
    if (notificationRecords.length === 0) {
        return (React.createElement(Wrap, Object.assign({}, style),
            React.createElement(Alert, { status: "info", w: "100%" },
                React.createElement(FormattedMessage, { id: "notificationTray.empty" }))));
    }
    return (React.createElement(Wrap, Object.assign({}, style),
        React.createElement(InfiniteScroll, { pageStart: 0, loadMore: loadMore, hasMore: hasMore, loader: React.createElement(NotificationRecordSkeleton, null), useWindow: false },
            React.createElement(Stack, { key: "infinite-stack", spacing: "-1px", mb: hasMore ? '-1px' : '' }, notificationRecords.map((record) => (React.createElement(NotificationRecordItem, { key: record.id, record: record, onClick: onClick, onBadgeClick: onBadgeClick })))))));
}
//# sourceMappingURL=NotificationRecordList.js.map